// Shared expert-presentation helpers used by the email preview, the selected
// expert cards and the search result rows. Single copy so the bio truncation
// limit can't drift between them.

// Mirrors EmailHelper::EXPERT_DESCRIPTION_WORD_LIMIT in components/notify so
// every surface truncates exactly where the real email will. If you change
// one, change the other.
export const EXPERT_DESCRIPTION_WORD_LIMIT = 50;

// Truncate `text` to at most `limit` whitespace-separated words. Returns
// { text, truncated } so callers can render a "Read more" affordance only
// when the cut actually happened.
export function truncateWords(text, limit) {
  if (!text) return { text: "", truncated: false };
  const trimmed = text.trim();
  const words = trimmed.split(/\s+/);
  if (words.length <= limit) return { text: trimmed, truncated: false };
  return { text: `${words.slice(0, limit).join(" ")}...`, truncated: true };
}

// The V1 /sources/{ref} URL the *real* newsjacking email puts in front of the
// recipient (a journalist). Mirrors the email's
// `links.source_url(expert[:migrate_id] || expert[:slug])` logic exactly so
// the EmailPreview is faithful to what gets sent. Returns null when neither
// identifier is available or V1 isn't configured (renders a plain name).
export function emailExpertProfileUrl(expert) {
  const ref = expert.migrate_id || expert.slug;
  const v1Host = globalThis.Qwoted?.V1_URL;
  if (!ref || !v1Host) return null;
  return `${v1Host}/sources/${ref}`;
}

// The profile link for the *admin* picker UI (selected cards + search rows),
// where the admin is vetting an expert — a different purpose from the email.
//
//   - migrate_id present (+ V1 configured): the expert has a real V1 source
//     page; link there (same target the email/recipient would hit).
//   - otherwise: a V2-native expert (or V1 not configured) — link to the V2
//     expert profile. Same-origin app, so a root-relative path is enough and
//     it works even when V1_URL is unset.
export function adminExpertProfileUrl(expert) {
  const v1Host = globalThis.Qwoted?.V1_URL;
  if (expert.migrate_id && v1Host) {
    return `${v1Host}/sources/${expert.migrate_id}?version=v1`;
  }
  if (expert.slug) return `/experts/${expert.slug}`;
  return null;
}
